import { Button } from "@jkast90/kast-common/ui";
import { BaseDialog } from "@common/components/ui";
import styles from "./GroupSelectDialog.module.css";

/** What the dialog shows of a group: its id and name, either spelling. */
export interface SelectableGroup {
  id?: number;
  group_id?: number;
  name?: string;
  group_name?: string;
}

interface GroupSelectDialogProps<G extends SelectableGroup> {
  open: boolean;
  onClose: () => void;
  onSelectGroup: (group: G) => void;
  groups: G[];
  title?: string;
  emptyMessage?: string;
}

/**
 * Dialog for selecting a group from a list
 */
export default function GroupSelectDialog<G extends SelectableGroup>({
  open,
  onClose,
  onSelectGroup,
  groups,
  title = "Select a Group",
  emptyMessage = "No groups available",
}: GroupSelectDialogProps<G>) {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={title}
      className={styles.compactDialog}
    >
      <div style={{ padding: "1rem" }}>
        {groups.length === 0 ? (
          <p style={{ textAlign: "center", color: "var(--text-muted)" }}>
            {emptyMessage}
          </p>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {groups.map((group) => (
              <Button
                variant="primary"
                key={group.id || group.group_id}
                onClick={() => {
                  onSelectGroup(group);
                  onClose();
                }}
                style={{
                  width: "100%",
                  textAlign: "left",
                  padding: "0.75rem 1rem",
                }}
              >
                {group.name || group.group_name}
              </Button>
            ))}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </BaseDialog>
  );
}
